
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Mining from "../pages/mining/page";
import Logistics from "../pages/logistics/page";
import Contact from "../pages/contact/page";
import ProductMarket from "../pages/product-market/page";
import Gallery from "../pages/gallery/page";
import Layout from "../components/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "mining",
        element: <Mining />,
      },
      {
        path: "logistics",
        element: <Logistics />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "product-market",
        element: <ProductMarket />,
      },
      {
        path: "gallery",
        element: <Gallery />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
